module.exports = __webpack_public_path__ + "img/icon-ywqn-head-1.ed3d1d4c.png";